<template>
  <v-dialog v-model="userDetalhesModal" scrollable persistent full-width max-width='933'>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="titulo-detalhes pl-4  mt-2 mb-2 headline">{{user.id === '' ? 'Novo usuário' : user.nome }}</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn icon @click.native="userDetalhesModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-form name="form-cadastro" ref="itemForm">
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12>
                <v-text-field
                name="nome"
                label="Nome"
                :rules="rules.name"
                :value="typeof user.nome !== 'undefined' ? user.nome : ''"
                @input="updateName"
                required
                >
                </v-text-field>                
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs11 sm5 md5>
                <v-text-field
                  label="Login"
                  :rules="rules.login"
                  @input="updateLogin"
                  :value="user.login">
                </v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Login utilizado para acessar o sistema.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 sm5 md5>
                <v-text-field
                label="Senha"
                :rules="rules.password"
                @input="updatePassword"
                :type="passwordFieldType"
                :value="user.senha">
                </v-text-field>
              </v-flex>
               <v-flex xs1 sm1 md1 pt-4 pl-3>
                 <v-icon class="link" @click="toggleVisibility" slot="activator" v-show="passwordFieldType == 'password'" color="gray">visibility</v-icon>
                 <v-icon class="link" @click="toggleVisibility" slot="activator" v-show="passwordFieldType == 'text'" color="gray">visibility_off</v-icon>
                <v-tooltip right>
                  <v-icon class="link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Senha utilizado para acessar o sistema.</span>
                </v-tooltip>
              </v-flex>
            </v-layout> 
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm6 md6 pr-2>
                <v-text-field
                label="E-mail"
                :rules="rules.email"
                @input="updateEmail"
                :value="user.email">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pl-2>
                <v-text-field
                  label="Telefone"
                  @input="updatePhone"
                  :rules="rules.phone"
                  :value="user.telefone">
                </v-text-field>
              </v-flex>
            </v-layout>           
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm6 md6 pr-2>
                <v-text-field
                label="Departamento"
                @input="updateDepartment"
                :value="user.departamento">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 pl-2>
                <p>Ativo</p>
                <SelectionBtn :value="user.active" @input="toggleActive"/>
              </v-flex>      
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 mt-3 class="text-xs-center">
                <v-spacer></v-spacer>
                <v-btn flat outline round color="green" class="mb-4" :disabled="loadingItemAction" @click.native="updateUser()"><v-icon left>done_all</v-icon>Gravar</v-btn>              
              </v-flex>
            </v-layout>
          <v-progress-linear class="loading-modal" v-if="loadingItemAction" color="error" v-bind:indeterminate="true"></v-progress-linear>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectionBtn from '@/components/SelectionBtn'
export default {
  name: 'user-detalhes',
  components: {
    SelectionBtn
  },
  data () {
    return {
      ativo: false,
      passwordFieldType: 'password',
      rules: {
        name: [
          (v) => v.length > 0 || 'Insira um nome'
        ],
        login: [
          (v) => v.length > 0 || 'Insira um login'
        ],
        password: [
          (v) => v.length > 0 || 'Insira uma senha'
        ],
        email: [
          (v) => v.length > 0 || 'Insira um e-mail'
        ],
        phone: [
          (v) => !!v > 0 || 'Insira um telefone'
        ]
      }
    }
  },
  created () {
  },
  methods: {
    updateUser () {
      if (this.$refs.itemForm.validate()) {
        this.$store.dispatch('updateUser')
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Verifique os campos em vermelho'
        })
      }
    },
    toggleActive (value) {
      this.$store.commit('toggleUserActive')
    },
    updateName (value) {
      this.$store.commit('updateUserName', value)
    },
    updateLogin (value) {
      this.$store.commit('updateUserLogin', value)
    },
    updatePassword (value) {
      this.$store.commit('updateUserPassword', value)
    },
    updatePhone (value) {
      this.$store.commit('updateUserPhone', value)
    },
    updateEmail (value) {
      this.$store.commit('updateUserEmail', value)
    },
    updateDepartment (value) {
      this.$store.commit('updateUserDepartment', value)
    },
    close () {
      this.$store.commit('closeUser')
    },
    toggleVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    }
  },
  computed: {
    loadingUserAction () {
      return this.$store.getters.loadingUserAction
    },
    user () {
      return this.$store.getters.selectedUser
    },
    userDetalhesModal: {
      get () {
        return this.$store.getters.userVisible
      },
      set () {
        this.dataTags = ''
        this.$store.commit('toggleUserModal', false)
      }
    }
  }
}
</script>
<style>
.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{
  left: 23px!important;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
/* ajustes */
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
color: #838789
}
</style>



// WEBPACK FOOTER //
// usuarioDetalhe.vue?398332d3